import {
  IconHome,
  IconTools,
  IconActivity,
  IconMap2,
  IconPhone,
} from '@tabler/icons-react';
import { ElementType } from 'react';

export interface NavLinkItem {
  id: string;
  href: string;
  label: string;
  Icon: ElementType;
}

export const DEFAULT_NAV_LINKS: NavLinkItem[] = [
  { id: 'o-nas', href: '#o-nas', label: 'O nas', Icon: IconHome },
  { id: 'serwis', href: '#serwis', label: 'Serwis', Icon: IconTools },
  { id: 'porady', href: '#porady', label: 'Porady', Icon: IconActivity },
  { id: 'wycieczki', href: '#wycieczki', label: 'Wycieczki', Icon: IconMap2 },
  { id: 'kontakt', href: '#kontakt', label: 'Kontakt', Icon: IconPhone },
];
